<template>
  <div class="wage-excel-upload">
    <v-card class="upload-card">
      <v-card-text>
        <v-divider class="my-1"></v-divider>
        <!-- 임금연월 및 지급일 입력 -->
        <div class="wage-info-section">
          <div class="wage-info-inputs">
            <FormatMonth />
            <div class="d-flex" style="width: 800px;">
              <v-text-field v-model="paymentDate" label="지급일" placeholder="YYYY-MM-DD" variant="outlined"
                prepend-icon="mdi-calendar" type="date" density="compact" class="payment-date-input mr-6" hide-details></v-text-field>
              <v-file-input v-model="selectedFile" label="엑셀 파일 선택" accept=".xlsx,.xls" prepend-icon="mdi-file-excel"
                variant="outlined" @update:model-value="handleFileSelect" :loading="isUploading"
                hide-details density="compact"></v-file-input>
                <v-btn @click="uploadExcel" :disabled="!selectedFile || selectedFile.length === 0 || isUploading"
              color="primary" :loading="isUploading" prepend-icon="mdi-upload" class="ml-1">
              엑셀 업로드
            </v-btn>
            </div>
          </div>
        </div>

        <v-divider class="my-1"></v-divider>
        <!-- 파일 업로드 -->

        <div class="file-upload-section">
          <!-- 엑셀 업로드 및 다운로드 드롭다운 -->
          <div class="button-group">
            <v-menu>
              <template v-slot:activator="{ props }">
                <v-btn v-bind="props" color="primary" prepend-icon="mdi-file-excel" class="mr-1">
                  엑셀 관리
                  <v-icon>mdi-chevron-down</v-icon>
                </v-btn>
              </template>
              <v-list>
  
                <v-list-item @click="downloadTemplate('임금엑셀업로드양식.xlsx')">
                  <template v-slot:prepend>
                    <v-icon>mdi-file-download</v-icon>
                  </template>
                  <v-list-item-title>엑셀 양식 다운로드</v-list-item-title>
                </v-list-item>
                <v-list-item @click="downloadExcelData" v-if="excelData.length > 0">
                  <template v-slot:prepend>
                    <v-icon>mdi-file-excel-outline</v-icon>
                  </template>
                  <v-list-item-title>데이터 엑셀 다운로드</v-list-item-title>
                </v-list-item>
                <v-divider class="my-1" v-if="calcData.length > 0"></v-divider>
                <v-list-item @click="downloadAdjustmentTemplate" v-if="calcData.length > 0">
                  <template v-slot:prepend>
                    <v-icon color="orange">mdi-file-edit</v-icon>
                  </template>
                  <v-list-item-title>공제조정 양식 다운로드</v-list-item-title>
                </v-list-item>
                <v-list-item @click="triggerAdjustmentFileInput" v-if="calcData.length > 0">
                  <template v-slot:prepend>
                    <v-icon color="orange">mdi-file-upload</v-icon>
                  </template>
                  <v-list-item-title>공제조정 엑셀 업로드</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>

            <!-- 임금대장 및 명세서 드롭다운 -->
            <v-menu v-if="excelData.length > 0">
              <template v-slot:activator="{ props }">
                <v-btn v-bind="props" color="success" prepend-icon="mdi-file-document" class="mr-1" 
                  :loading="isGenerating" :disabled="isGenerating">
                  임금 문서 생성
                  <v-icon>mdi-chevron-down</v-icon>
                </v-btn>
              </template>
              <v-list>
                <v-list-item @click="makeWageExcel('admin')">
                  <template v-slot:prepend>
                    <v-icon>mdi-file-excel</v-icon>
                  </template>
                  <v-list-item-title>고객용 임금대장</v-list-item-title>
                </v-list-item>
                <v-list-item @click="makeWageExcel('fnA')">
                  <template v-slot:prepend>
                    <v-icon>mdi-file-excel</v-icon>
                  </template>
                  <v-list-item-title>회계처리용 임금대장</v-list-item-title>
                </v-list-item>
                <v-list-item @click="getWagePdfExcelUploadData">
                  <template v-slot:prepend>
                    <v-icon>mdi-file</v-icon>
                  </template>
                  <v-list-item-title>임금명세서</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </div>

          <!-- SMS 발송 버튼 -->
          <div class="button-group">
            <v-btn variant="outlined" color="orange" prepend-icon="mdi-mail" @click="openSmsDialog"
              v-if="excelData.length > 0">
              임금명세서 발송
            </v-btn>
            <WageTransaction :hasData="excelData.length > 0" :dataCount="excelData.length" />
            <v-btn variant="outlined" color="indigo" prepend-icon="mdi-compare" @click="openBeforeAfterDialog"
              v-if="calcData.length > 0" class="ml-1">
              비과세 적용 효과
            </v-btn>
            <v-btn variant="outlined" color="deep-purple" prepend-icon="mdi-calendar-range" @click="openYearlyBeforeAfterDialog"
              class="ml-1">
              1년치 비교
            </v-btn>
          </div>

          <WageExcelBeforeAfter ref="wageExcelBeforeAfterRef" :excelData="excelData" :calcData="calcData" />
          <WageBeforeAfterYearly ref="wageBeforeAfterYearlyRef" />

          <AligoSMS ref="aligoSmsRef" />
          <!-- 공제조정 엑셀 업로드용 숨겨진 파일 인풋 -->
          <input 
            type="file" 
            ref="adjustmentFileInput" 
            accept=".xlsx,.xls" 
            style="display: none" 
            @change="handleAdjustmentFileUpload"
          />
        </div>
        <v-divider class="my-1"></v-divider>

        <!-- 업로드된 데이터 미리보기 -->
        <div v-if="excelData.length > 0" class="data-preview mt-6">
          <div class="preview-header">
            <h3 class="preview-title">저장된 데이터</h3>
            <v-btn-toggle v-model="tableViewMode" color="primary" density="compact" variant="outlined">
              <v-btn value="edit" size="small" prepend-icon="mdi-table-edit">
                편집 테이블
              </v-btn>
              <v-btn value="view" size="small" prepend-icon="mdi-table">
                조회 테이블
              </v-btn>
            </v-btn-toggle>

            <v-btn @click="copyLunchToFoodDeduction" color="purple" size="small" variant="outlined" 
              class="ml-2">
              중식대 = 식비공제
            </v-btn>

            <!-- 퇴직금 중식대 포함/미포함 토글 버튼 -->
            <v-btn 
              @click="toggleRetirementLunch" 
              :color="isRetireLunchIncluded ? 'teal' : 'brown'" 
              size="small" 
              :variant="isRetireLunchIncluded ? 'flat' : 'outlined'"
              class="ml-2" 
              :loading="isRetirementUpdating"
              :prepend-icon="isRetireLunchIncluded ? 'mdi-check-circle' : 'mdi-close-circle'"
            >
              퇴직금 중식대 {{ isRetireLunchIncluded ? '포함' : '미포함' }}
            </v-btn>

            <!-- 공제조정 적용 상태 표시 -->
            <v-chip 
              v-if="isAdjustmentApplied" 
              color="orange" 
              variant="flat"
              size="small"
              class="ml-2"
              closable
              @click:close="resetAdjustment"
            >
              🔧 공제조정 적용됨
            </v-chip>

            <v-spacer></v-spacer>
            <div class="header-controls">
              <div class="usage-guide">
                <span class="guide-text" v-if="tableViewMode === 'edit'">💡 조작방법: 셀 안에서 방향키(↑↓←→)로 셀 이동</span>
                <span class="guide-text" v-if="tableViewMode === 'edit'">💾 저장방법: 셀 안에서 Ctrl + Enter로 전체 저장</span>
                <span class="guide-text" v-if="tableViewMode === 'view'">👀 조회 모드: 데이터를 읽기 전용으로 확인할 수 있습니다</span>
              </div>
            </div>
          </div>
          <div class="data-count">총 {{ excelData.length }}개의 데이터가 저장되었습니다.</div>

          <div class="table-container">
            <!-- 편집 가능한 테이블 -->
            <table v-if="tableViewMode === 'edit'" class="editable-wage-table">
              <thead>
                <tr>
                  <th>이름</th>
                  <th>입퇴사여부</th>
                  <th style="min-width: 100px;">휴대폰</th>
                  <th>생년월일</th>
                  <th>입사일</th>
                  <th>직책</th>
                  <th>기본급</th>
                  <th>연장수당</th>
                  <th>야간수당</th>
                  <th>휴일수당</th>
                  <th>연차수당</th>
                  <th>장기근속</th>
                  <th>선임수당</th>
                  <th>상여금</th>
                  <th>교육비</th>
                  <th>보존수당</th>
                  <th>기타수당</th>
                  <th>당직수당</th>
                  <th>중식대</th>
                  <th>차량비</th>
                  <th>양육비</th>
                  <th>임금 총액</th>
                  <th>국민연금</th>
                  <th>건강보험</th>
                  <th>장기요양</th>
                  <th>고용보험</th>
                  <th>실업급여</th>
                  <th>산재보험</th>
                  <th>식비공제</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, index) in excelData" :key="index" class="view-wage-table-tr">
                  <td><input type="text" v-model="item.empName" class="table-input text-center"
                      @keydown="handleKeyDown($event, index, 0)" :data-row="index" :data-col="0" maxlength="10" /></td>
                  <td><input type="text" v-model="item.empInOutStatus" class="table-input text-center"
                      @keydown="handleKeyDown($event, index, 1)" :data-row="index" :data-col="1" maxlength="10" /></td>
                  <td><input type="text" v-model="item.empPhone" class="table-input text-center"
                      @keydown="handleKeyDown($event, index, 2)" :data-row="index" :data-col="2" /></td>
                  <td><input type="text" v-model="item.birthDate" class="table-input text-center"
                      @keydown="handleKeyDown($event, index, 3)" :data-row="index" :data-col="3" /></td>
                  <td><input type="text" v-model="item.empInYm" class="table-input text-center"
                      @keydown="handleKeyDown($event, index, 4)" :data-row="index" :data-col="4" /></td>
                  <td><input type="text" v-model="item.empJob" class="table-input text-center"
                      @keydown="handleKeyDown($event, index, 5)" :data-row="index" :data-col="5" /></td>
                  <td><input type="text" v-model="item.base" class="table-input text-right"
                      @keydown="handleKeyDown($event, index, 6)" :data-row="index" :data-col="6" /></td>
                  <td><input type="text" v-model="item.overtime" class="table-input text-right"
                      @keydown="handleKeyDown($event, index, 7)" :data-row="index" :data-col="7" /></td>
                  <td><input type="text" v-model="item.night" class="table-input text-right"
                      @keydown="handleKeyDown($event, index, 8)" :data-row="index" :data-col="8" /></td>
                  <td><input type="text" v-model="item.holiday" class="table-input text-right"
                      @keydown="handleKeyDown($event, index, 9)" :data-row="index" :data-col="9" /></td>
                  <td><input type="text" v-model="item.dayOffPay" class="table-input text-right"
                      @keydown="handleKeyDown($event, index, 10)" :data-row="index" :data-col="10" /></td>
                  <td><input type="text" v-model="item.longTerm" class="table-input text-right"
                      @keydown="handleKeyDown($event, index, 11)" :data-row="index" :data-col="11" /></td>
                  <td><input type="text" v-model="item.sunim" class="table-input text-right"
                      @keydown="handleKeyDown($event, index, 12)" :data-row="index" :data-col="12" /></td>
                  <td><input type="text" v-model="item.bonus" class="table-input text-right"
                      @keydown="handleKeyDown($event, index, 13)" :data-row="index" :data-col="13" /></td>
                  <td><input type="text" v-model="item.eduPay" class="table-input text-right"
                      @keydown="handleKeyDown($event, index, 14)" :data-row="index" :data-col="14" /></td>
                  <td><input type="text" v-model="item.bojon" class="table-input text-right"
                      @keydown="handleKeyDown($event, index, 15)" :data-row="index" :data-col="15" /></td>
                  <td><input type="text" v-model="item.etc" class="table-input text-right"
                      @keydown="handleKeyDown($event, index, 16)" :data-row="index" :data-col="16" /></td>
                  <td><input type="text" v-model="item.dang" class="table-input text-right"
                      @keydown="handleKeyDown($event, index, 17)" :data-row="index" :data-col="17" /></td>
                  <td><input type="text" v-model="item.lunch" class="table-input text-right"
                      @keydown="handleKeyDown($event, index, 18)" :data-row="index" :data-col="18" /></td>
                  <td><input type="text" v-model="item.car" class="table-input text-right"
                      @keydown="handleKeyDown($event, index, 19)" :data-row="index" :data-col="19" /></td>
                  <td><input type="text" v-model="item.childcare" class="table-input text-right"
                      @keydown="handleKeyDown($event, index, 20)" :data-row="index" :data-col="20" /></td>
                  <td><input type="text" v-model="item.total" class="table-input text-right"
                      @keydown="handleKeyDown($event, index, 21)" :data-row="index" :data-col="21" /></td>
                  <td><input type="text" v-model="item.yeon" class="table-input text-right"
                      @keydown="handleKeyDown($event, index, 22)" :data-row="index" :data-col="22" /></td>
                  <td><input type="text" v-model="item.gun" class="table-input text-right"
                      @keydown="handleKeyDown($event, index, 23)" :data-row="index" :data-col="23" /></td>
                  <td><input type="text" v-model="item.jang" class="table-input text-right"
                    @keydown="handleKeyDown($event, index, 24)" :data-row="index" :data-col="24" /></td>
                  <td><input type="text" v-model="item.go" class="table-input text-right"
                      @keydown="handleKeyDown($event, index, 25)" :data-row="index" :data-col="25" /></td>
                  <td><input type="text" v-model="item.sil" class="table-input text-right"
                      @keydown="handleKeyDown($event, index, 26)" :data-row="index" :data-col="26" /></td>
                  <td><input type="text" v-model="item.san" class="table-input text-right"
                      @keydown="handleKeyDown($event, index, 27)" :data-row="index" :data-col="27" /></td>
                  <td><input type="text" v-model="item.sik" class="table-input text-right"
                      @keydown="handleKeyDown($event, index, 28)" :data-row="index" :data-col="28" /></td>
                </tr>
                <!-- 합산행 -->
                <tr class="sum-row">
                  <td class="sum-label" colspan="6">합계</td>
                  <td class="sum-value">{{ formatNumber(calculateSum('base')) }}</td>
                  <td class="sum-value">{{ formatNumber(calculateSum('overtime')) }}</td>
                  <td class="sum-value">{{ formatNumber(calculateSum('night')) }}</td>
                  <td class="sum-value">{{ formatNumber(calculateSum('holiday')) }}</td>
                  <td class="sum-value">{{ formatNumber(calculateSum('dayOffPay')) }}</td>
                  <td class="sum-value">{{ formatNumber(calculateSum('longTerm')) }}</td>
                  <td class="sum-value">{{ formatNumber(calculateSum('sunim')) }}</td>
                  <td class="sum-value">{{ formatNumber(calculateSum('bonus')) }}</td>
                  <td class="sum-value">{{ formatNumber(calculateSum('eduPay')) }}</td>
                  <td class="sum-value">{{ formatNumber(calculateSum('bojon')) }}</td>
                  <td class="sum-value">{{ formatNumber(calculateSum('etc')) }}</td>
                  <td class="sum-value">{{ formatNumber(calculateSum('dang')) }}</td>
                  <td class="sum-value">{{ formatNumber(calculateSum('lunch')) }}</td>
                  <td class="sum-value">{{ formatNumber(calculateSum('car')) }}</td>
                  <td class="sum-value">{{ formatNumber(calculateSum('childcare')) }}</td>
                  <td class="sum-value">{{ formatNumber(calculateSum('total')) }}</td>
                  <td class="sum-value">{{ formatNumber(calculateSum('yeon')) }}</td>
                  <td class="sum-value">{{ formatNumber(calculateSum('gun')) }}</td>
                  <td class="sum-value">{{ formatNumber(calculateSum('jang')) }}</td>
                  <td class="sum-value">{{ formatNumber(calculateSum('go')) }}</td>
                  <td class="sum-value">{{ formatNumber(calculateSum('sil')) }}</td>
                  <td class="sum-value">{{ formatNumber(calculateSum('san')) }}</td>
                  <td class="sum-value">{{ formatNumber(calculateSum('sik')) }}</td>
                </tr>
              </tbody>
            </table>

            <!-- 조회 전용 테이블 -->
            <table v-else class="view-wage-table">
              <thead>
                <!-- 그룹 헤더 -->
                <tr class="group-header">
                  <th colspan="5" class="group-title">사원정보</th>
                  <th colspan="16" class="group-title">임금구성</th>
                  <th colspan="3" class="group-title">조정내역</th>
                  <th colspan="11" class="group-title">근로자 공제</th>
                  <th colspan="8" class="group-title">기관 공제</th>
                </tr>
                <!-- 세부 헤더 -->
                <tr class="detail-header">
                  <th>이름</th>
                  <th>입퇴사여부</th>
                  <th>직책</th>
                  <th>생년월일</th>
                  <th>입사일</th>
                  <th>기본급</th>
                  <th>연장수당</th>
                  <th>야간수당</th>
                  <th>휴일수당</th>
                  <th>연차수당</th>
                  <th>장기근속</th>
                  <th>선임수당</th>
                  <th>상여금</th>
                  <th>교육비</th>
                  <th>보존수당</th>
                  <th>기타수당</th>
                  <th>당직수당</th>
                  <th>중식대</th>
                  <th>차량비</th>
                  <th>양육비</th>
                  <th class="total-column">임금합계</th>
                  <th>과세임금</th>
                  <th>통상임금</th>
                  <th>최저임금</th>
                  <th>연금</th>
                  <th>건강</th>
                  <th>장기</th>
                  <th>고용</th>
                  <th>소득세</th>
                  <th>지방세</th>
                  <th>지원공제</th>
                  <th>식비공제</th>
                  <th>기타공제</th>
                  <th>연말정산</th>
                  <th class="total-column">합계</th>
                  <th>연금</th>
                  <th>건강</th>
                  <th>장기</th>
                  <th>고용</th>
                  <th>실업</th>
                  <th>산재</th>
                  <th>기타</th>
                  <th class="total-column">합계</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, index) in calcData" :key="index">
                  <td class="table-cell text-center">{{ item.empName || '' }}</td>
                  <td class="table-cell text-center">{{ item.empInOutStatus || '' }}</td>
                  <td class="table-cell text-center">{{ item.empJob || '' }}</td>
                  <td class="table-cell text-center">{{ item.empBirth || '' }}</td>
                  <td class="table-cell text-center">{{ item.empInDate || '' }}</td>
                  <td class="table-cell text-right">{{ item.base || 0 }}</td>
                  <td class="table-cell text-right">{{ item.overtime || 0 }}</td>
                  <td class="table-cell text-right">{{ item.night || 0 }}</td>
                  <td class="table-cell text-right">{{ item.holiday || 0 }}</td>
                  <td class="table-cell text-right">{{ item.dayOffPay || 0 }}</td>
                  <td class="table-cell text-right">{{ item.longTerm || 0 }}</td>
                  <td class="table-cell text-right">{{ item.sunim || 0 }}</td>
                  <td class="table-cell text-right">{{ item.bonus || 0 }}</td>
                  <td class="table-cell text-right">{{ item.eduPay || 0 }}</td>
                  <td class="table-cell text-right">{{ item.bojon || 0 }}</td>
                  <td class="table-cell text-right">{{ item.etc || 0 }}</td>
                  <td class="table-cell text-right">{{ item.dang || 0 }}</td>
                  <td class="table-cell text-right">{{ item.lunch || 0 }}</td>
                  <td class="table-cell text-right">{{ item.car || 0 }}</td>
                  <td class="table-cell text-right">{{ item.childcare || 0 }}</td>
                  <td class="table-cell text-right" style="font-weight: 700">{{ item.total || 0 }}</td>
                  <td class="table-cell text-right">{{ item.taxable || 0 }}</td>
                  <td class="table-cell text-right">{{ item.usual || 0 }}</td>
                  <td class="table-cell text-right">{{ item.minimum || 0 }}</td>
                  <td class="table-cell text-right">{{ item.l_yeon || 0 }}</td>
                  <td class="table-cell text-right">{{ item.l_gun || 0 }}</td>
                  <td class="table-cell text-right">{{ item.l_jang || 0 }}</td>
                  <td class="table-cell text-right">{{ item.l_go || 0 }}</td>
                  <td class="table-cell text-right">{{ item.l_so || 0 }}</td>
                  <td class="table-cell text-right">{{ item.l_ji || 0 }}</td>
                  <td class="table-cell text-right">{{ item.l_jiwon || 0 }}</td>
                  <td class="table-cell text-right">{{ item.l_sik || 0 }}</td>
                  <td class="table-cell text-right">{{ item.l_etc || 0 }}</td>
                  <td class="table-cell text-right">{{ item.l_yearEnd || 0 }}</td>
                  <td class="table-cell text-right" style="font-weight: 700">{{ item.l_total || 0 }}</td>
                  <td class="table-cell text-right">{{ item.c_yeon || 0 }}</td>
                  <td class="table-cell text-right">{{ item.c_gun || 0 }}</td>
                  <td class="table-cell text-right">{{ item.c_jang || 0 }}</td>
                  <td class="table-cell text-right">{{ item.c_go || 0 }}</td>
                  <td class="table-cell text-right">{{ item.c_sil || 0 }}</td>
                  <td class="table-cell text-right">{{ item.c_san || 0 }}</td>
                  <td class="table-cell text-right">{{ item.c_out || 0 }}</td>
                  <td class="table-cell text-right" style="font-weight: 700">{{ item.c_total || 0 }}</td>
                </tr>
                <!-- 합산행 -->
                <tr class="sum-row">
                  <td class="sum-label" colspan="5">합계</td>
                  <td class="sum-value">{{ formatNumber(calculateSumFromCalcData('base')) }}</td>
                  <td class="sum-value">{{ formatNumber(calculateSumFromCalcData('overtime')) }}</td>
                  <td class="sum-value">{{ formatNumber(calculateSumFromCalcData('night')) }}</td>
                  <td class="sum-value">{{ formatNumber(calculateSumFromCalcData('holiday')) }}</td>
                  <td class="sum-value">{{ formatNumber(calculateSumFromCalcData('dayOffPay')) }}</td>
                  <td class="sum-value">{{ formatNumber(calculateSumFromCalcData('longTerm')) }}</td>
                  <td class="sum-value">{{ formatNumber(calculateSumFromCalcData('sunim')) }}</td>
                  <td class="sum-value">{{ formatNumber(calculateSumFromCalcData('bonus')) }}</td>
                  <td class="sum-value">{{ formatNumber(calculateSumFromCalcData('eduPay')) }}</td>
                  <td class="sum-value">{{ formatNumber(calculateSumFromCalcData('bojon')) }}</td>
                  <td class="sum-value">{{ formatNumber(calculateSumFromCalcData('etc')) }}</td>
                  <td class="sum-value">{{ formatNumber(calculateSumFromCalcData('dang')) }}</td>
                  <td class="sum-value">{{ formatNumber(calculateSumFromCalcData('lunch')) }}</td>
                  <td class="sum-value">{{ formatNumber(calculateSumFromCalcData('car')) }}</td>
                  <td class="sum-value">{{ formatNumber(calculateSumFromCalcData('childcare')) }}</td>
                  <td class="sum-value" style="font-weight: 700">{{ formatNumber(calculateSumFromCalcData('total')) }}</td>
                  <td class="sum-value">{{ formatNumber(calculateSumFromCalcData('taxable')) }}</td>
                  <td class="sum-value">{{ formatNumber(calculateSumFromCalcData('usual')) }}</td>
                  <td class="sum-value">{{ formatNumber(calculateSumFromCalcData('minimum')) }}</td>
                  <td class="sum-value">{{ formatNumber(calculateSumFromCalcData('l_yeon')) }}</td>
                  <td class="sum-value">{{ formatNumber(calculateSumFromCalcData('l_gun')) }}</td>
                  <td class="sum-value">{{ formatNumber(calculateSumFromCalcData('l_jang')) }}</td>
                  <td class="sum-value">{{ formatNumber(calculateSumFromCalcData('l_go')) }}</td>
                  <td class="sum-value">{{ formatNumber(calculateSumFromCalcData('l_so')) }}</td>
                  <td class="sum-value">{{ formatNumber(calculateSumFromCalcData('l_ji')) }}</td>
                  <td class="sum-value">{{ formatNumber(calculateSumFromCalcData('l_jiwon')) }}</td>
                  <td class="sum-value">{{ formatNumber(calculateSumFromCalcData('l_sik')) }}</td>
                  <td class="sum-value">{{ formatNumber(calculateSumFromCalcData('l_etc')) }}</td>
                  <td class="sum-value">{{ formatNumber(calculateSumFromCalcData('l_yearEnd')) }}</td>
                  <td class="sum-value" style="font-weight: 700">{{ formatNumber(calculateSumFromCalcData('l_total')) }}</td>
                  <td class="sum-value">{{ formatNumber(calculateSumFromCalcData('c_yeon')) }}</td>
                  <td class="sum-value">{{ formatNumber(calculateSumFromCalcData('c_gun')) }}</td>
                  <td class="sum-value">{{ formatNumber(calculateSumFromCalcData('c_jang')) }}</td>
                  <td class="sum-value">{{ formatNumber(calculateSumFromCalcData('c_go')) }}</td>
                  <td class="sum-value">{{ formatNumber(calculateSumFromCalcData('c_sil')) }}</td>
                  <td class="sum-value">{{ formatNumber(calculateSumFromCalcData('c_san')) }}</td>
                  <td class="sum-value">{{ formatNumber(calculateSumFromCalcData('c_out')) }}</td>
                  <td class="sum-value" style="font-weight: 700">{{ formatNumber(calculateSumFromCalcData('c_total')) }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </v-card-text>
    </v-card>
  </div>
</template>

<script setup lang="ts">
import axios from 'axios';
import { computed, onMounted, ref, watch } from 'vue';
import { useStore } from 'vuex';
import * as XLSX from 'xlsx';
import FormatMonth from '../../../components/admin/common/datePicker/FormatMonth.vue'
import AligoSMS from '../../../components/api/AligoSMS.vue';
import WageTransaction from '../../../components/admin/wage/WageTransaction.vue';
import WageExcelBeforeAfter from '../../../components/admin/wage/WageExcelBeforeAfter.vue';
import WageBeforeAfterYearly from '../../../components/admin/wage/WageBeforeAfterYearly.vue';

const store = useStore();

const sisulName = ref<string>(store.state.AdminSisulName);

// 반응형 데이터
const selectedFile = ref<File[]>([]);
const isUploading = ref(false);
const isGenerating = ref(false);
const excelData = ref<any[]>([]);
const calcData = ref<any[]>([]);
const paymentDate = ref('');
const tableViewMode = ref<'edit' | 'view'>('edit');
const isAdjustmentApplied = ref(false); // 공제조정 엑셀 업로드 적용 상태
const isRetirementUpdating = ref(false); // 퇴직금 중식대 옵션 업데이트 로딩 상태

// 퇴직금 중식대 포함 여부 (excelData의 첫 번째 항목에서 확인)
const isRetireLunchIncluded = computed(() => {
  if (!excelData.value || excelData.value.length === 0) return false;
  const firstItem = excelData.value[0];
  return firstItem.retireLunchInclude === 1 || firstItem.retireLunchInclude === '1';
});

// 파일 선택 핸들러
const handleFileSelect = (files: File[]) => {
  selectedFile.value = files;
};

// 엑셀 업로드 - 백엔드 API 호출
const uploadExcel = async () => {
  if (!selectedFile.value || selectedFile.value.length === 0) {
    store.commit('showSnackbar', {
      text: "파일을 선택해주세요.",
      color: "warning"
    });
    return;
  }

  if (!paymentDate.value) {
    store.commit('showSnackbar', {
      text: "지급일을 입력해주세요.",
      color: "warning"
    });
    return;
  }

  isUploading.value = true;

  try {
    const formData = new FormData();
    formData.append('excelFile', selectedFile.value[0]);
    formData.append('wageMonth', store.state.AdminYYMM);
    formData.append('paymentDate', paymentDate.value);
    formData.append('sisulName', sisulName.value);

    const response = await axios.post(`/api/uploadWageExcel/${store.state.AdminSisulCode}`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });

    if (response.data.success) {
      excelData.value = response.data.data;

      store.commit('showSnackbar', {
        text: response.data.message,
        color: "success"
      });

      // 파일 선택 인풋 비우기
      selectedFile.value = [];

      // 업로드 후 조회 테이블 데이터도 함께 업데이트
      await getWageExcelUploadData();
    } else {
      store.commit('showSnackbar', {
        text: response.data.message,
        color: "error"
      });
    }

  } catch (error) {
    console.error('엑셀 업로드 중 오류:', error);
    store.commit('showSnackbar', {
      text: "엑셀 업로드 중 오류가 발생했습니다.",
      color: "error"
    });
  } finally {
    isUploading.value = false;
  }
};

// 엑셀 양식 다운로드
const downloadTemplate = (fileName: string) => {
  window.location.href = `/api/downloadTemplateExcel/${fileName}`;
};
const getWageExcelUploadData = async () => {
  try {
    // 데이터 재조회 시 공제조정 적용 상태 초기화
    isAdjustmentApplied.value = false;
    
    const response = await axios.get(`/api/getWageExcelUploadData/${store.state.AdminSisulCode}/${store.state.AdminYYMM}`);
    const responseData = response.data;
    // 컨트롤러 응답 구조: { success: boolean, result?: array, message?: string }
    if (responseData.success && responseData.excelData) {
      // 응답 데이터가 배열인지 확인하고 안전하게 할당
      if (Array.isArray(responseData.excelData)) {
        excelData.value = responseData.excelData;
        calcData.value = responseData.calcData;
        store.commit('showSnackbar', {
          text: `임금 데이터를 성공적으로 로드했습니다. (${responseData.excelData.length}건)`,
          color: "success"
        });
      } else {
        excelData.value = [];
        store.commit('showSnackbar', {
          text: "임금 데이터 형식이 올바르지 않습니다.",
          color: "warning"
        });
      }
      return responseData;
    } else {
      // success가 false이거나 데이터가 없는 경우
      excelData.value = [];
      const message = responseData.message || "임금 데이터가 없습니다.";
      store.commit('showSnackbar', {
        text: message,
        color: "info"
      });
    }
  } catch (error) {
    console.error("임금 데이터 조회 오류:", error);
    // 오류 발생 시 빈 배열로 초기화
    excelData.value = [];

    store.commit('showSnackbar', {
      text: "임금 데이터 조회 중 오류가 발생했습니다.",
      color: "error"
    });
  }
};
watch(
  () => store.state.AdminYYMM,
  (newValue) => {
    if (newValue) {
      getWageExcelUploadData();
    }
  }
);
onMounted(async () => {
  await getWageExcelUploadData();
  const now = new Date().toISOString().split('T')[0];
  paymentDate.value = now;
})

const makeWageExcel = async (type: string) => {
  // 데이터 유효성 검사
  if (!excelData.value || excelData.value.length === 0) {
    store.commit('showSnackbar', {
      text: "생성할 임금 데이터가 없습니다. 먼저 엑셀을 업로드하거나 데이터를 조회해주세요.",
      color: "warning"
    });
    return;
  }

  if (!paymentDate.value) {
    store.commit('showSnackbar', {
      text: "지급일을 입력해주세요.",
      color: "warning"
    });
    return;
  }

  try {
    isGenerating.value = true;

    // 공제조정 적용 여부에 따라 다른 API 호출
    const apiUrl = isAdjustmentApplied.value 
      ? '/api/makeWageExcelWithAdjustment' 
      : '/api/makeWageExcel';

    const requestData: any = {
      excelData: excelData.value,
      wageMonth: store.state.AdminYYMM,
      bizGubun: store.state.AdminBizGubun,
      paymentDate: paymentDate.value,
      sisulName: sisulName.value,
      type: type
    };

    // 공제조정 적용된 경우 calcData도 함께 전송
    if (isAdjustmentApplied.value) {
      requestData.calcData = calcData.value;
    }

    const response = await axios.post(apiUrl, requestData, {
      responseType: 'blob'
    });

    const blob = new Blob([response.data], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    });

    const url = window.URL.createObjectURL(blob);

    const link = document.createElement('a');
    link.href = url;
    link.download = `${type === 'fnA' ? '회계처리용' : '고객용'}_임금대장_${store.state.AdminYYMM}.xlsx`;
    document.body.appendChild(link);
    link.click();

    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);

    store.commit('showSnackbar', {
      text: "임금대장 엑셀 파일이 성공적으로 다운로드되었습니다.",
      color: "success"
    });

  } catch (error) {
    console.error('임금대장 출력 중 오류:', error);
    store.commit('showSnackbar', {
      text: "임금대장 출력 중 오류가 발생했습니다.",
      color: "error"
    });
  } finally {
    isGenerating.value = false;
  }
}

const getWagePdfExcelUploadData = async () => {
  try {
    if (!paymentDate.value) {
      store.commit('showSnackbar', {
        text: "지급일을 입력해주세요.",
        color: "warning"
      });
      return;
    }

    // 공제조정 적용 여부에 따라 다른 API 호출
    const apiUrl = isAdjustmentApplied.value 
      ? "/api/getWagePdfExcelUploadDataWithAdjustment"
      : "/api/getWagePdfExcelUploadData";

    const requestData: any = {
      wageList: excelData.value,
      wageMonth: store.state.AdminYYMM,
      paymentDate: paymentDate.value
    };

    // 공제조정 적용된 경우 calcData도 함께 전송
    if (isAdjustmentApplied.value) {
      requestData.calcData = calcData.value;
    }

    // 서버로부터 PDF 데이터를 요청
    const response = await axios.post(
      apiUrl,
      requestData,
      {
        responseType: "json",
      }
    );

    // 서버로부터 받은 데이터에서 PDF Base64 문자열 추출
    const pdfBase64 = response.data.pdf;

    // Base64 문자열을 이진 데이터로 변환
    const binaryString = window.atob(pdfBase64);
    const len = binaryString.length;
    const bytes = new Uint8Array(len);
    for (let i = 0; i < len; i++) {
      bytes[i] = binaryString.charCodeAt(i);
    }

    // 이진 데이터로부터 Blob 생성
    const blob = new Blob([bytes], { type: "application/pdf" });

    // Blob URL 생성
    const url = window.URL.createObjectURL(blob);

    // 새 창에서 PDF 열기
    const newWindow = window.open(url, "_blank");
    if (newWindow) {
      newWindow.focus();
    } else {
      console.error("새 창을 열 수 없습니다. 팝업 차단 설정을 확인하세요.");
    }
  } catch (error) {
    console.error("PDF 미리보기 중 에러 발생:", error);
  }
};
const aligoSmsRef = ref();
const adjustmentFileInput = ref<HTMLInputElement | null>(null);
const wageExcelBeforeAfterRef = ref();
const wageBeforeAfterYearlyRef = ref();

const openSmsDialog = () => {
  aligoSmsRef.value?.openDialog(calcData.value);
};

const openBeforeAfterDialog = () => {
  wageExcelBeforeAfterRef.value?.openDialog();
};

const openYearlyBeforeAfterDialog = () => {
  wageBeforeAfterYearlyRef.value?.openDialog();
};

// 공제조정 파일 인풋 트리거
const triggerAdjustmentFileInput = () => {
  adjustmentFileInput.value?.click();
};

// 공제조정 양식 다운로드 (현재 calcData 기반)
const downloadAdjustmentTemplate = () => {
  if (!calcData.value || calcData.value.length === 0) {
    store.commit('showSnackbar', {
      text: "다운로드할 데이터가 없습니다.",
      color: "warning"
    });
    return;
  }

  // 양식에 포함할 컬럼 정의 (l_so, l_ji, c_out 제외)
  const headers = [
    '이름', '연금(근로자)', '건강(근로자)', '장기(근로자)', '고용(근로자)', 
    '지원공제', '식비공제', '기타공제', '연말정산',
    '연금(기관)', '건강(기관)', '장기(기관)', '고용(기관)', '실업(기관)', '산재(기관)'
  ];

  // 이름만 채우고 나머지는 0으로 설정
  const excelRows = [headers];
  
  calcData.value.forEach((item: any) => {
    const row = [
      item.empName || '',
      0, 0, 0, 0,  // 연금, 건강, 장기, 고용 (근로자)
      0, 0, 0, 0,  // 지원공제, 식비공제, 기타공제, 연말정산
      0, 0, 0, 0, 0, 0  // 연금, 건강, 장기, 고용, 실업, 산재 (기관)
    ];
    excelRows.push(row);
  });

  // xlsx 워크북 생성
  const ws = XLSX.utils.aoa_to_sheet(excelRows);
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, '공제조정');

  // 컬럼 너비 설정
  ws['!cols'] = [
    { wch: 10 }, // 이름
    { wch: 12 }, { wch: 12 }, { wch: 12 }, { wch: 12 }, // 근로자 공제
    { wch: 10 }, { wch: 10 }, { wch: 10 }, { wch: 10 }, // 지원, 식비, 기타, 연말정산
    { wch: 12 }, { wch: 12 }, { wch: 12 }, { wch: 12 }, { wch: 12 }, { wch: 12 } // 기관 공제
  ];

  // 파일 다운로드
  XLSX.writeFile(wb, `공제조정양식_${store.state.AdminYYMM}.xlsx`);

  store.commit('showSnackbar', {
    text: "공제조정 양식이 다운로드되었습니다.",
    color: "success"
  });
};

// 공제조정 엑셀 업로드 처리 (calcData 임시 변경, DB 저장 X)
const handleAdjustmentFileUpload = async (event: Event) => {
  const target = event.target as HTMLInputElement;
  const file = target.files?.[0];
  
  if (!file) return;

  try {
    const data = await file.arrayBuffer();
    const workbook = XLSX.read(data);
    const sheetName = workbook.SheetNames[0];
    const worksheet = workbook.Sheets[sheetName];
    const jsonData = XLSX.utils.sheet_to_json(worksheet) as any[];

    if (jsonData.length === 0) {
      store.commit('showSnackbar', {
        text: "업로드된 엑셀에 데이터가 없습니다.",
        color: "warning"
      });
      return;
    }

    // calcData 업데이트 (이름으로 매칭)
    let updatedCount = 0;
    
    jsonData.forEach((row: any) => {
      const empName = row['이름'];
      if (!empName) return;

      const targetItem = calcData.value.find((item: any) => item.empName === empName);
      if (targetItem) {
        // 근로자 공제 항목 업데이트
        targetItem.l_yeon = formatNumberValue(row['연금(근로자)']);
        targetItem.l_gun = formatNumberValue(row['건강(근로자)']);
        targetItem.l_jang = formatNumberValue(row['장기(근로자)']);
        targetItem.l_go = formatNumberValue(row['고용(근로자)']);
        targetItem.l_jiwon = formatNumberValue(row['지원공제']);
        targetItem.l_sik = formatNumberValue(row['식비공제']);
        targetItem.l_etc = formatNumberValue(row['기타공제']);
        targetItem.l_yearEnd = formatNumberValue(row['연말정산']);
        
        // 기관 공제 항목 업데이트
        targetItem.c_yeon = formatNumberValue(row['연금(기관)']);
        targetItem.c_gun = formatNumberValue(row['건강(기관)']);
        targetItem.c_jang = formatNumberValue(row['장기(기관)']);
        targetItem.c_go = formatNumberValue(row['고용(기관)']);
        targetItem.c_sil = formatNumberValue(row['실업(기관)']);
        targetItem.c_san = formatNumberValue(row['산재(기관)']);

        // l_total 재계산 (l_so, l_ji 포함)
        const newLTotal = 
          parseNumber(targetItem.l_yeon) + parseNumber(targetItem.l_gun) + 
          parseNumber(targetItem.l_jang) + parseNumber(targetItem.l_go) +
          parseNumber(targetItem.l_so) + parseNumber(targetItem.l_ji) +
          parseNumber(targetItem.l_jiwon) + parseNumber(targetItem.l_sik) + 
          parseNumber(targetItem.l_etc) + parseNumber(targetItem.l_yearEnd);
        targetItem.l_total = formatNumberValue(newLTotal);

        // c_total 재계산 (c_out 포함)
        const newCTotal = 
          parseNumber(targetItem.c_yeon) + parseNumber(targetItem.c_gun) + 
          parseNumber(targetItem.c_jang) + parseNumber(targetItem.c_go) +
          parseNumber(targetItem.c_sil) + parseNumber(targetItem.c_san) +
          parseNumber(targetItem.c_out);
        targetItem.c_total = formatNumberValue(newCTotal);

        // 실지급액 재계산 (임금총액 - 근로자공제합계)
        const total = parseNumber(targetItem.total);
        targetItem.realMoney = formatNumberValue(total - newLTotal);

        updatedCount++;
      }
    });

    // 파일 인풋 초기화
    target.value = '';

    if (updatedCount > 0) {
      // 공제조정 적용 상태값 설정
      isAdjustmentApplied.value = true;
      
      // 조회 테이블로 자동 전환
      tableViewMode.value = 'view';
      
      store.commit('showSnackbar', {
        text: `공제조정이 임시 적용되었습니다. (${updatedCount}건) - DB에 저장되지 않습니다.`,
        color: "success"
      });
    } else {
      store.commit('showSnackbar', {
        text: "매칭되는 이름이 없어 업데이트할 데이터가 없습니다.",
        color: "warning"
      });
    }

  } catch (error) {
    console.error('공제조정 엑셀 업로드 중 오류:', error);
    store.commit('showSnackbar', {
      text: "공제조정 엑셀 업로드 중 오류가 발생했습니다.",
      color: "error"
    });
  }
};

// 숫자 파싱 헬퍼 함수
const parseNumber = (value: any): number => {
  if (value === null || value === undefined || value === '') return 0;
  const num = parseFloat(value.toString().replace(/,/g, ''));
  return isNaN(num) ? 0 : num;
};

// 숫자 포맷 헬퍼 함수
const formatNumberValue = (value: any): string => {
  const num = parseNumber(value);
  return new Intl.NumberFormat('ko-KR').format(num);
};

// 공제조정 초기화 (원래 계산값으로 복원)
const resetAdjustment = async () => {
  isAdjustmentApplied.value = false;
  await getWageExcelUploadData();
  store.commit('showSnackbar', {
    text: "공제조정이 초기화되었습니다.",
    color: "info"
  });
};

const handleKeyDown = (event: KeyboardEvent, row: number, col: number) => {
  // Ctrl+Enter로 전체 저장
  if (event.ctrlKey && event.key === 'Enter') {
    event.preventDefault();
    saveAllData();
    return;
  }

  // 방향키 이동
  if (['ArrowUp', 'ArrowDown', 'ArrowLeft', 'ArrowRight'].includes(event.key)) {
    event.preventDefault();

    const totalCols = 28; // 총 컬럼 수 (27->28로 변경)
    const totalRows = excelData.value.length;

    let newRow = row;
    let newCol = col;

    switch (event.key) {
      case 'ArrowUp':
        newRow = Math.max(0, row - 1);
        break;
      case 'ArrowDown':
        newRow = Math.min(totalRows - 1, row + 1);
        break;
      case 'ArrowLeft':
        newCol = Math.max(0, col - 1);
        break;
      case 'ArrowRight':
        newCol = Math.min(totalCols - 1, col + 1);
        break;
    }

    // 새로운 셀로 포커스 이동
    const nextInput = document.querySelector(`input[data-row="${newRow}"][data-col="${newCol}"]`) as HTMLInputElement;
    if (nextInput) {
      nextInput.focus();
    }
  }
};

// 전체 데이터 저장
const saveAllData = async () => {
  if (!excelData.value || excelData.value.length === 0) {
    store.commit('showSnackbar', {
      text: "저장할 데이터가 없습니다.",
      color: "warning"
    });
    return;
  }

  try {
    const response = await axios.post('/api/updateWageExcelUploadData', {
      excelData: excelData.value
    });

    if (response.data.success) {
      store.commit('showSnackbar', {
        text: response.data.message,
        color: "success"
      });
    } else {
      store.commit('showSnackbar', {
        text: response.data.message,
        color: "error"
      });
    }
    await getWageExcelUploadData();
  } catch (error) {
    console.error('전체 데이터 저장 중 오류:', error);
    store.commit('showSnackbar', {
      text: "전체 데이터 저장 중 오류가 발생했습니다.",
      color: "error"
    });
  }
};

const downloadExcelData = async () => {
  try {
    if (!excelData.value || excelData.value.length === 0) {
      store.commit('showSnackbar', {
        text: "다운로드할 데이터가 없습니다.",
        color: "warning"
      });
      return;
    }

    // 엑셀 헤더 정의
    const headers = [
      '이름', '입퇴사여부', '휴대폰', '생년월일', '입사일', '직책',
      '기본급', '연장수당', '야간수당', '휴일수당', '연차수당', '장기근속',
      '선임수당', '상여금', '교육비', '보존수당', '기타수당', '당직수당',
      '중식대', '차량비', '양육비', '임금 총액', '국민연금', '건강보험', '고용보험',
      '실업급여', '산재보험', '식비공제'
    ];

    // 데이터를 배열 형태로 변환
    const excelRows = [headers];

    excelData.value.forEach(item => {
      const row = [
        item.empName || '',
        item.empInOutStatus || '',
        item.empPhone || '',
        item.birthDate || '',
        item.empInYm || '',
        item.empJob || '',
        item.base || '',
        item.overtime || '',
        item.night || '',
        item.holiday || '',
        item.dayOffPay || '',
        item.longTerm || '',
        item.sunim || '',
        item.bonus || '',
        item.eduPay || '',
        item.bojon || '',
        item.etc || '',
        item.dang || '',
        item.lunch || '',
        item.car || '',
        item.childcare || '',
        item.total || '',
        item.yeon || '',
        item.gun || '',
        item.jang || '',
        item.go || '',
        item.sil || '',
        item.san || '',
        item.sik || ''
      ];
      excelRows.push(row);
    });

    // CSV 형태로 변환하여 다운로드
    const csvContent = excelRows.map(row =>
      row.map(cell => `"${cell}"`).join(',')
    ).join('\n');

    const blob = new Blob(['\uFEFF' + csvContent], {
      type: 'text/csv;charset=utf-8;'
    });

    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = `임금데이터_${store.state.AdminYYMM}.csv`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);

    store.commit('showSnackbar', {
      text: "임금 데이터가 성공적으로 다운로드되었습니다.",
      color: "success"
    });
  } catch (error) {
    console.error('임금 데이터 다운로드 중 오류:', error);
    store.commit('showSnackbar', {
      text: "임금 데이터 다운로드 중 오류가 발생했습니다.",
      color: "error"
    });
  }
};

// 합산 계산 함수
const calculateSum = (field: string): number => {
  if (!excelData.value || excelData.value.length === 0) {
    return 0;
  }

  return excelData.value.reduce((sum, item) => {
    const value = parseFloat(item[field]) || 0;
    return sum + value;
  }, 0);
};

// 숫자 포맷팅 함수
const formatNumber = (value: number): string => {
  return new Intl.NumberFormat('ko-KR').format(value);
};

// 합산 계산 함수 (calcData 기반)
const calculateSumFromCalcData = (field: string): number => {
  if (!calcData.value || calcData.value.length === 0) {
    return 0;
  }

  return calcData.value.reduce((sum, item) => {
    const value = parseFloat(item[field]?.toString().replace(/,/g, '') || '0');
    return sum + value;
  }, 0);
};

// 중식대를 식비공제로 복사하는 함수
const copyLunchToFoodDeduction = async () => {
  if (!excelData.value || excelData.value.length === 0) {
    store.commit('showSnackbar', {
      text: "복사할 데이터가 없습니다.",
      color: "warning"
    });
    return;
  }

  try {
    // 모든 데이터의 중식대 값을 식비공제로 복사
    excelData.value.forEach((item: any) => {
      if (item.lunch) {
        item.sik = item.lunch;
      }
    });

    // 변경된 데이터를 서버에 저장
    const response = await axios.post('/api/updateWageExcelUploadData', {
      excelData: excelData.value
    });

    if (response.data.success) {
      store.commit('showSnackbar', {
        text: "중식대 금액이 식비공제로 성공적으로 복사되었습니다.",
        color: "success"
      });
      
      // 조회 테이블 데이터도 업데이트
      await getWageExcelUploadData();
    } else {
      store.commit('showSnackbar', {
        text: response.data.message || "데이터 저장 중 오류가 발생했습니다.",
        color: "error"
      });
    }
  } catch (error) {
    console.error('중식대→식비공제 복사 중 오류:', error);
    store.commit('showSnackbar', {
      text: "중식대→식비공제 복사 중 오류가 발생했습니다.",
      color: "error"
    });
  }
};

// 퇴직금 중식대 포함/미포함 옵션 업데이트
// 퇴직금 중식대 포함/미포함 토글
const toggleRetirementLunch = async () => {
  if (!excelData.value || excelData.value.length === 0) {
    store.commit('showSnackbar', {
      text: "업데이트할 데이터가 없습니다.",
      color: "warning"
    });
    return;
  }

  try {
    isRetirementUpdating.value = true;
    
    // 현재 상태의 반대로 토글
    const newIncludeLunch = !isRetireLunchIncluded.value;

    const response = await axios.post('/api/updateRetirementLunchOption', {
      sisulCode: store.state.AdminSisulCode,
      wageMonth: store.state.AdminYYMM,
      includeLunch: newIncludeLunch
    });

    if (response.data.success) {
      store.commit('showSnackbar', {
        text: response.data.message,
        color: "success"
      });
      
      // 조회 테이블 데이터 업데이트 (wageExcelUpCalc에서 옵션에 따라 재계산됨)
      await getWageExcelUploadData();
    } else {
      store.commit('showSnackbar', {
        text: response.data.message || "업데이트 중 오류가 발생했습니다.",
        color: "error"
      });
    }
  } catch (error) {
    console.error('퇴직금 중식대 옵션 업데이트 중 오류:', error);
    store.commit('showSnackbar', {
      text: "퇴직금 중식대 옵션 업데이트 중 오류가 발생했습니다.",
      color: "error"
    });
  } finally {
    isRetirementUpdating.value = false;
  }
};

</script>

<style scoped lang="scss">
@use '@/assets/styles/pages/wage-excel-upload';
</style>
